export default __webpack_public_path__ + "static/media/warely_pay_icon.ac03ae8f.png";